import { HandType } from '@ps/web-poker-types';
import { formatCurrency } from '@ps/web-poker-utils';

import { formatRange } from '..';
import i18n from '../../i18n';
import type { Language } from '../../types';
import { isLimitGame } from '../helpers';
import { AttributeKey } from '../types';

export interface ZoomAttributes {
  minChipsLimit: number;
  maxBuyIn: number;
  blinds: number[];
  currency: number | string;
  ante: number;
  game: number;
  stakes: number[];
  isPlayMoney: number;
  structure: number;
  scalePM: number;
  loBet: number;
  hiBet: number;
}

export default function zoomAttrFormatter(
  {
    minChipsLimit,
    maxBuyIn,
    blinds,
    currency,
    isPlayMoney,
    game,
    stakes,
    ante,
    structure,
    scalePM,
    loBet,
    hiBet
  }: ZoomAttributes,
  language?: Language
) {
  const i18nInstance = i18n(language);
  const options = { shorten: true, isPlayMoney, scalePM };
  const attributes = [
    {
      name: i18nInstance('TXTWBCLI_Buy_In'),
      value: formatRange({
        range: isLimitGame(structure) ? [minChipsLimit] : [minChipsLimit, maxBuyIn],
        currency,
        separator: isLimitGame(structure) ? '+' : '-',
        options
      }),
      key: AttributeKey.buyIn
    }
  ];

  if (ante) {
    attributes.push({
      name: i18nInstance('TXTWBCLI_Ante'),
      value: formatCurrency(ante, currency, { ...options, separators: true }),
      key: AttributeKey.ante
    });
  }

  if (game === HandType.STUD || game === HandType.RAZZ) {
    attributes.push({
      name: i18nInstance('TXTWBCLI_Stakes'),
      value: formatRange({
        range: isLimitGame(structure) ? [loBet, hiBet] : stakes,
        currency,
        options
      }),
      key: AttributeKey.stakes
    });
  } else {
    attributes.push({
      name: i18nInstance('TXTWBCLI_Stakes'),
      value: formatRange({
        range: isLimitGame(structure) ? [loBet, hiBet] : blinds,
        currency,
        options
      }),
      key: AttributeKey.stakes
    });
  }
  return attributes;
}
